import { useMsal } from "@azure/msal-react";
import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { apiAccessRequest } from "../../../constants";
import { useUserContext } from "../../../contexts";
import { BuildUrl } from "../../../helpers/ApiHelpers";

export const LthCapUsage = ({ doctorId, dailyCap }: { doctorId: number; dailyCap: number | null }) => {
	const { instance } = useMsal();
	const { account } = useUserContext();
	const [usage, setUsage] = useState<{ used: number } | null>(null);
	const [failed, setFailed] = useState(false);

	useEffect(() => {
		let cancelled = false;
		const load = async () => {
			try {
				const token = await instance.acquireTokenSilent({ account, scopes: apiAccessRequest.scopes });
				const response = await fetch(BuildUrl(`Doctor/${doctorId}/lth-capacity`), {
					headers: { Authorization: `Bearer ${token.accessToken}` }
				});
				if (!response.ok) throw new Error("Could not load LTH usage");
				const data = await response.json();
				if (!cancelled) setUsage(data);
			} catch {
				if (!cancelled) setFailed(true);
			}
		};
		load();
		return () => { cancelled = true; };
	}, [account, doctorId, instance]);

	return (
		<Typography variant="body2" color={usage && dailyCap !== null && usage.used >= dailyCap ? "warning.main" : "text.secondary"}
			sx={{ whiteSpace: "nowrap" }}>
			{usage ? `${usage.used} used today` : failed ? "Usage unavailable" : "Loading usage…"}
		</Typography>
	);
};
